import { render, staticRenderFns } from "./AbsenceHourForFullShiftField.vue?vue&type=template&id=6aab1462&"
import script from "./AbsenceHourForFullShiftField.vue?vue&type=script&lang=js&"
export * from "./AbsenceHourForFullShiftField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aab1462')) {
      api.createRecord('6aab1462', component.options)
    } else {
      api.reload('6aab1462', component.options)
    }
    module.hot.accept("./AbsenceHourForFullShiftField.vue?vue&type=template&id=6aab1462&", function () {
      api.rerender('6aab1462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/absences/fields/AbsenceHourForFullShiftField.vue"
export default component.exports